import { apiPost, apiPath } from '@/lib/api/client';

export interface LoginRequest {
  email: string;
  password: string;
}

/**
 * Mirrors cx-alm `LoginResponse.java` (camelCase, JsonInclude(NON_NULL)).
 * The auth store only consumes `token`; the rest is surfaced for diagnostics
 * and for the UI to greet the user without decoding the JWT itself.
 */
export interface LoginResponse {
  token: string;
  expiresIn: number;
  userId?: string;
  email?: string;
  tenantId?: string;
  roles?: string[];
  permissions?: string[];
}

/**
 * POST /api/v1/auth/login on cx-alm. Returns a signed JWT carrying
 * sub, email, tenant_id, role, roles, permissions, exp.
 */
export async function login(body: LoginRequest): Promise<LoginResponse> {
  return apiPost<LoginResponse, LoginRequest>(apiPath('auth', 'login'), body);
}

/** Logout endpoint is not implemented server-side yet — clearing the
 *  token client-side is enough since cx-alm is fully stateless. */
export async function logout(): Promise<void> {
  return Promise.resolve();
}
